<div class="tableHolder table-responsive">
    <table mat-table [dataSource]="dataSource" class="table">
        <!-- position -->
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element">{{ element.position }}</td>
        </ng-container>

        <!-- campaign_name -->
        <ng-container matColumnDef="campaign_name">
            <th mat-header-cell *matHeaderCellDef>Campaign Name</th>
            <td mat-cell *matCellDef="let element">
                {{ element.campaign_name }}
            </td>
        </ng-container>

        <!-- start_date -->
        <ng-container matColumnDef="start_date">
            <th mat-header-cell *matHeaderCellDef>Start Date</th>
            <td mat-cell *matCellDef="let element">
                {{ element.start_date }}
            </td>
        </ng-container>

        <!-- end_date -->
        <ng-container matColumnDef="end_date">
            <th mat-header-cell *matHeaderCellDef>End Date</th>
            <td mat-cell *matCellDef="let element">{{ element.end_date }}</td>
        </ng-container>

        <!-- status -->
        <ng-container matColumnDef="last_modified">
            <th mat-header-cell *matHeaderCellDef>Last Modified</th>
            <td mat-cell *matCellDef="let element">
                {{ element.last_modified }}
            </td>
        </ng-container>

        <!-- created on -->
        <ng-container matColumnDef="created_on">
            <th mat-header-cell *matHeaderCellDef>Created On</th>
            <td mat-cell *matCellDef="let element">{{ element.created_on }}</td>
        </ng-container>

        <!-- industry -->
        <ng-container matColumnDef="industry">
            <th mat-header-cell *matHeaderCellDef>Industry</th>
            <td mat-cell *matCellDef="let element">
                {{ element.industry }}
            </td>
        </ng-container>

        <!-- status -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
                <span
                    class="status-badge br-20 d-block text-white bg-warning px-3 py-2 text-center"
                    >{{ element.status }}</span
                >
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
